import React, { useEffect } from 'react';
import ShapeName from './ShapeName';
import { getLogisticsHistory } from '../../../actions/logistics';
import { getSeedHistory } from '../../../actions/plan';
import { useDispatch } from 'react-redux';
import { PLANTING_PLAN_TYPE_ID } from '../../../constants';

const ShapePopupOne = props => {

    const { farmId, selectedPlanTypeId } = props;
    const { custom: { from, to } } = props.searchParams;
    const dispatch = useDispatch();
    useEffect(() => {
        const paramsObj = {
            farm_uuid: farmId,
            range_type: "todate",
            from_date: from,
            to_date: to,
            plan_type_id: selectedPlanTypeId,
            include_events: true
        }

        const seedParamsObj = {
            farm_uuid: farmId,
            range_type: "todate",
            from_date: from,
            to_date: to,
            plan_type_id: PLANTING_PLAN_TYPE_ID,
            include_events: true
        }
        dispatch(getLogisticsHistory(paramsObj));
        dispatch(getSeedHistory(seedParamsObj));
    }, [farmId]);
    return <ShapeName {...props}>
        {({ shapeName, shapeDetail, editButton, isField, customerName }) => {
            return <div className={`shape-popup ${!isField ? "shape-popup-offloadsite" : ""}`}>
                <div className="shape-popup-body">
                    <div className="shape-popup-title">
                        <div>
                            <div>{shapeName}</div>
                            <div className='customer-name text-muted text-truncate' title={customerName}>{customerName}</div>
                        </div>
                        {editButton}
                    </div>
                    <div className="shape-popup-detail">
                        {shapeDetail}
                    </div>
                </div>
            </div>
        }}
    </ShapeName>;
};

export default ShapePopupOne;